class ReadMoreText extends HTMLElement {
  connectedCallback() {
    this.hiddenEl = this.querySelector('.read-more-text__hidden');
    this.btn = this.querySelector('.read-more-text__toggle');
    this.moreLabel = this.querySelector('.read-more-text__more');
    this.lessLabel = this.querySelector('.read-more-text__less');
    this.animating = false;

    this.btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (this.animating) return;
      this.btn.getAttribute('aria-expanded') === 'true' ? this.collapse() : this.expand();
    });
  }

  onTransitionEnd(callback) {
    const handler = (e) => {
      // Ignore bubbled transitionend events from unrelated child elements
      if (e.target !== this.hiddenEl || e.propertyName !== 'max-height') return;
      this.hiddenEl.removeEventListener('transitionend', handler);
      callback();
    };
    this.hiddenEl.addEventListener('transitionend', handler);
  }

  expand() {
    this.animating = true;
    this.hiddenEl.hidden = false;
    this.hiddenEl.style.overflow = 'hidden';
    this.hiddenEl.style.maxHeight = '0px';
    const targetHeight = this.hiddenEl.scrollHeight;

    requestAnimationFrame(() => {
      this.hiddenEl.style.transition = 'max-height 0.35s ease';
      this.hiddenEl.style.maxHeight = targetHeight + 'px';
    });

    this.onTransitionEnd(() => {
      this.hiddenEl.style.maxHeight = 'none';
      this.hiddenEl.style.overflow = '';
      this.animating = false;
    });

    this.btn.setAttribute('aria-expanded', 'true');
    this.moreLabel.hidden = true;
    this.lessLabel.hidden = false;
  }

  collapse() {
    this.animating = true;
    this.hiddenEl.style.overflow = 'hidden';
    this.hiddenEl.style.maxHeight = this.hiddenEl.scrollHeight + 'px';

    requestAnimationFrame(() => {
      this.hiddenEl.style.transition = 'max-height 0.35s ease';
      this.hiddenEl.style.maxHeight = '0px';
    });

    this.onTransitionEnd(() => {
      this.hiddenEl.hidden = true;
      this.hiddenEl.style.maxHeight = '';
      this.hiddenEl.style.overflow = '';
      this.animating = false;
    });

    this.btn.setAttribute('aria-expanded', 'false');
    this.moreLabel.hidden = false;
    this.lessLabel.hidden = true;
  }
}

if (!customElements.get('read-more-text')) {
  customElements.define('read-more-text', ReadMoreText);
}